import { ReactNode } from 'react';
import AppShell from '../../components/AppShell';
import EnvBanner from '../../components/EnvBanner';
import type { SidebarKey } from '../../components/Sidebar';

const ContentWidthPx = 980;
const WideContentWidthPx = 1320;

interface AdminPageProps {
  active: SidebarKey;
  eyebrow: string;
  title: string;
  intro: ReactNode;
  rightSlot?: ReactNode;
  wide?: boolean;
  children: ReactNode;
}

/** An admin page in the app's shell: the sidebar, the top bar and the environment banner stay put while the content scrolls. */
export default function AdminPage({ active, eyebrow, title, intro, rightSlot, wide = false, children }: AdminPageProps) {
  return (
    <AppShell active={active} breadcrumbs={[{ label: 'Admin' }, { label: title }]} rightSlot={rightSlot}>
      <EnvBanner />
      <div style={{ flex: 1, minHeight: 0, overflowY: 'auto' }}>
        <div style={{ padding: '32px var(--gutter-inner)', maxWidth: wide ? WideContentWidthPx : ContentWidthPx }}>
          <div className="eyebrow" style={{ marginBottom: 10 }}>{eyebrow}</div>
          <h1 className="t-h2-xs" style={{ margin: '0 0 10px' }}>{title}</h1>
          <p className="t-body" style={{ margin: '0 0 28px', maxWidth: 620 }}>{intro}</p>
          {children}
        </div>
      </div>
    </AppShell>
  );
}
